import * as firebase from "firebase/app"
import "firebase/auth"
import AppService from "./app-service"

export default class AuthService extends AppService {

  currentFirebaseUser() {
    return firebase.auth().currentUser
  }

  currentUser() {
    return this.http.get("auth/whoami")
  }

  login(email, password) {

    if (email)
      email = email.trim()

    return firebase.auth().signInWithEmailAndPassword(email, password)    
  }

  logout() {    
    return firebase.auth().signOut()
  }

  onAuthStateChanged(callback) {
    return firebase.auth().onAuthStateChanged(callback)
  }

  async loadCurrentUser(fbUser) {

    if (!fbUser)
      fbUser = firebase.auth().currentUser

    this.store.commit("auth/setFbUser", fbUser)
    this.store.commit("auth/setUser", await this.currentUser())
  }

  sendPasswordResetEmail(email) {
    return firebase.auth().sendPasswordResetEmail(email)    
  }

  async updatePassword(currentPassword, newPassword) {

    const user = firebase.auth().currentUser

    await reauthenticateUser(user, currentPassword)        
    await user.updatePassword(newPassword)
    await this.loadCurrentUser()
  }

  async updateEmail(currentPassword, newEmail) {
    
    const user = firebase.auth().currentUser

    await reauthenticateUser(user, currentPassword)        
    await user.updateEmail(newEmail)
    await this.updateCurrentUser({ email: newEmail })
    await this.loadCurrentUser()
  }

  async updateCurrentUser(data) {
    
    const id = this.store.state.auth.user.id
    const user = await this.http.put(`users/${id}`, data)
    
    this.store.commit("auth/setUser", user)
  }
}

function reauthenticateUser(user, currentPassword) {
    
  const credential = firebase.auth.EmailAuthProvider.credential(user.email, currentPassword)

  return user.reauthenticateWithCredential(credential)
}